var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.834,
    height: 11.834,
    viewBox: "0 0 11.834 11.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ab{fill:#262626;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M11.192,5.092H6.743V.643A.8.8,0,0,0,5.917,0a.8.8,0,0,0-.826.642V5.092H.642A.8.8,0,0,0,0,5.918a.8.8,0,0,0,.642.826H5.091v4.449a.8.8,0,0,0,.826.642.8.8,0,0,0,.826-.642V6.744h4.449a.8.8,0,0,0,.642-.826A.8.8,0,0,0,11.192,5.092Z",
    transform: "translate(0 -0.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.d78dd921.svg";
export { ForwardRef as ReactComponent };